import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme }) => `${theme.spacing(1)} 0 0`};
`;

export const TitleBar = styled.div`
  display: flex;
  align-items: start;
  gap: ${({ theme }) => theme.spacing(1.5)};

  width: 100%;
`;

export const TitleContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)};
`;

export const CheckboxContainer = styled.div`
  padding: ${({ theme }) => `${theme.spacing(0.5)} 0 0 0`};
  line-height: 62.5%;
`;
